import { bl_aat_engagement_hdr_RowClass } from '../../../dbschema/bl_aat_engagement_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class EngagementHdrContainerModel extends BaseContainerModel {
    bl_aat_engagement_hdr: bl_aat_engagement_hdr_RowClass = new bl_aat_engagement_hdr_RowClass();
}